module.exports = __webpack_public_path__ + "img/home-bg@2x.3e4330a1.png";